import type { ActionId } from "owa-mail-list-item-animation-store";
import { getIsDarkTheme } from "owa-fabric-theme";

export function getAnimationBackgroundColor(actionId: ActionId): "#442726" | "#FEF2F3" | "#393D1B" | "#DFF6DD" | "#FED9CC" | "#FFF4CE" | "#2B88D8" | "#EFF6FC" | "transparent" {
    const isDarkTheme = getIsDarkTheme();
    switch (actionId) {
        case "Delete":
            return isDarkTheme ? "#442726" : "#FEF2F3";
        case "Archive":
            return isDarkTheme ? "#393D1B" : "#DFF6DD";
        case "Snooze":
        case "Move":
            return isDarkTheme ? "#FED9CC" : "#FFF4CE";
        case "PinInitial":
        case "PinMiddle":
        case "PinFinal":
        case "AddRowFinal":
            return isDarkTheme ? "#2B88D8" : "#EFF6FC";
        
        case "-":
        case "None":
        case "ReadUnread":
        case "FlagUnflag":
        default:
            return "transparent";
    }
}
